import { AuthProvider } from '@hourly/contexts/AuthContext';
import { RequestConfig } from '@hourly/hooks/useRequest';
import { AxiosError } from 'axios';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router';
import { SnackbarNotifications, useNotifications } from '@shared/components/SnackbarNotifications';
import api from './api';
import { router } from './generated-router';
import { useSessionStore } from './stores/sessionStore';
import './app.css';

import.meta.glob('./routes/__app/**/data/events/*.ts', { eager: true });

const extractErrorMessage = (error: unknown) => {
  if (error instanceof AxiosError) {
    return error.response?.data.error_detailed_message || 'Something went wrong';
  } else if (typeof error === 'string') {
    return error;
  }
  return 'Something went wrong';
};

function App() {
  const { error: notifyError } = useNotifications();
  return (
    <AuthProvider api={api} useSessionStore={useSessionStore}>
      <RequestConfig
        config={{
          onError: (error) => {
            notifyError(extractErrorMessage(error));
          },
        }}>
        <RouterProvider router={createBrowserRouter(router as RouteObject[])} />
      </RequestConfig>
      <SnackbarNotifications />
    </AuthProvider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
